import React from 'react';
import { midas } from '@resurs/midas';
import { classNames } from '@resurs/hephaestus';
const Accordion = ({ children, values, dataCy }) => (React.createElement("div", { className: midas.accordion, "data-cy": dataCy },
    values.map((item) => {
        var _a;
        return (React.createElement("div", { key: item.key, className: midas.accordionItem },
            React.createElement("input", { type: "checkbox", name: "accordion-checkbox", id: item.value, hidden: true, checked: item.checked, onChange: () => undefined }),
            React.createElement("label", { className: classNames(midas.accordionHeader, midas.hand), htmlFor: item.value },
                item.value,
                item.items && (React.createElement("i", { className: classNames(midas.icon, midas.iconCaret) }))),
            React.createElement("div", { className: midas.accordionBody },
                React.createElement("ul", { className: midas.nav }, (_a = item.items) === null || _a === void 0 ? void 0 : _a.map((subItem) => (React.createElement("li", { key: subItem.key, className: midas.navItem }, subItem.value)))))));
    }),
    children));
export default Accordion;
